var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TextField from '../components/TextField';
import Field from './Field';
var RFFTextField = function (_a) {
    var fullWidth = _a.fullWidth, label = _a.label, name = _a.name, endAdornment = _a.endAdornment, others = __rest(_a, ["fullWidth", "label", "name", "endAdornment"]);
    return (React.createElement(Field, { name: name }, function (_a) {
        var input = _a.input, meta = _a.meta, props = __rest(_a, ["input", "meta"]);
        return (React.createElement(TextField, __assign({}, input, props, others, { fullWidth: fullWidth, label: label, endAdornment: endAdornment, error: meta.touched && !!meta.error, helperText: meta.touched && meta.error, onBlur: function (event) {
                input.onBlur && input.onBlur(event);
                others.onBlur && others.onBlur(event);
            } })));
    }));
};
RFFTextField.defaultProps = {
    fullWidth: false,
    endAdornment: 'disabled',
    label: '',
};
export default RFFTextField;
//# sourceMappingURL=TextField.js.map